// 系統變量
// 平台多語言存儲localStorage字段key
export const LOCAL_LANG_KEY_PINGTAI = 'tcma-pingtai-lang'
